module.exports = __webpack_public_path__ + "static/CleanAir-Mobile-Header-1080x550-Curve-Disclaimer-2x-745ddaa57a7b45501f87c6029be52e2f.png";